module.exports = __webpack_public_path__ + "img/account_circle-24px.e0e4bf64.svg";